const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  showCandidateForm: false,
};

const registerCandidateSlice = createSlice({
  name: "registerCandidate",
  initialState,
  reducers: {
    setShowCandidateForm: (state, action) => {
      state.showCandidateForm = action.payload;
    },
  },
});

export const { setShowCandidateForm } = registerCandidateSlice.actions;
export const selectShowCandidateForm = (state) =>
  state.registerCandidate.showCandidateForm;

export default registerCandidateSlice.reducer;
